export type TabType = "overview" | "entries" | "daily" | "charts" | "treasury";

export interface FilterParams {
  country?: string;
  payment_method?: string;
  direction?: string;
  date_from?: string;
  date_to?: string;
}

export interface FormDataType {
  date: string;
  heure: string;
  direction: string;
  country: string;
  payment_method: string;
  capital_amount: number;
  capital_currency: string;
  buy_platform: string;
  buy_rate: number;
  buy_fees: number;
  usdt_obtained: number;
  sell_platform: string;
  sell_rate: number;
  sale_amount: number;
  izi_rate: number;
  izi_amount: number;
  profit_percentage: number;
  gross_profit: number;
  fees: number;
  net_profit: number;
  profit_cad: number;
  expense_amount: number;
  expense_currency: string;
  expense_description: string;
  final_profit: number;
  final_profit_cad: number;
}

export interface UseSummaryProps {
  params: FilterParams;
}
export const DIRECTIONS = [
  { value: "CAD_TO_XAF", label: "CAD → XAF" },
  { value: "XAF_TO_CAD", label: "XAF → CAD" },
];

export const PAYMENT_METHODS = ["MTN", "ORANGE", "MOOV", "WAVE", "INTERAC", "OTHER"];

/** Frais opérateur appliqués sur le Montant IZI (sens CAD → XAF). */
export const DEFAULT_OPERATOR_FEE_RATE = 0.01;
export const OPERATOR_FEE_RATES: Record<string, number> = {
  MTN: 0.01,
  ORANGE: 0.0182,
};

export const getOperatorFeeRate = (paymentMethod?: string): number =>
  OPERATOR_FEE_RATES[(paymentMethod || "").toUpperCase()] ?? DEFAULT_OPERATOR_FEE_RATE;
